import React, { useState } from "react";
import {
  Button,
  Col,
  Container,
  Input,
  Row,
  ButtonGroup,
  Breadcrumb,
  BreadcrumbItem,
} from "reactstrap";
import { Link } from "react-router-dom";
import { DynamicTable } from "@workspace/common";
import "./BenefitsTableWrapper.scss";
import { useUserAuth } from "@workspace/login";
import { useSelector, useDispatch } from "react-redux";
import { DeleteCustomModal } from "@workspace/common";
import "simplebar/dist/simplebar.min.css";
import TableRowsPerPageWithNav from "@workspace/common/src/Components/DynamicTable/TableRowsPerPageWithNav";
import TableItemDisplay from "@workspace/common/src/Components/DynamicTable/TableItemDisplay";
import { TooltipWrapper } from "@workspace/common";
import { toast } from "react-toastify";
import { deleteBenefits } from "../../store/benefits/action";

const BenefitsTableWrapper = ({
  data,
  pageInfo,
  pageRequest,
  pageRequestSet,
  config,
  search,
  setSearch,
  activeRow,
  setTableConfig,
}) => {
  const dispatch = useDispatch();

  const benefitsMeta = useSelector(
    (state) => state.BenefitsReducer.benefitsMeta
  );
  const benefitDeleteMeta = useSelector(
    (state) => state.BenefitsReducer.benefitDeleteMeta
  );

  const { checkAnyRole, Role } = useUserAuth();

  // Delete modal states
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleDelete = () => {
    if (activeRow?.length === 0) {
      toast.error("Please select at least one record to delete.");
      return;
    }
    setIsDeleteModalOpen(true);
  };

  // Modal Delete benefits
  const confirmDelete = () => {
    dispatch(deleteBenefits({ ids: activeRow }));
    setIsDeleteModalOpen(false);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <Breadcrumb>
                <BreadcrumbItem>
                  <Link to="/settings/general">Settings</Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>Benefits</BreadcrumbItem>
              </Breadcrumb>
            </Col>
          </Row>
        </Container>
        <Container fluid>
          <Row>
            <Col lg={12}>
              <div
                className="listjs-table d-flex flex-column"
                style={{
                  height: "calc(100vh - 160px)",
                }}
              >
                <Row className="mb-2">
                  <Col>
                    <h4
                      style={{
                        whiteSpace: "nowrap",
                      }}
                    >
                      <span>Benefits ({pageInfo?.totalElements ?? 0})</span>
                    </h4>
                  </Col>
                </Row>
                <Row className="d-flex align-items-center mb-2">
                  <Col lg={6}>
                    <div className="d-flex flex-column flex-wrap align-items-start justify-content-start gap-2">
                      <div className="d-flex flex-row flex-wrap align-items-center gap-2">
                        {setSearch && (
                          <div className="search-box">
                            <form onSubmit={pageRequestSet.setSearchTerm}>
                              <Input
                                type="text"
                                placeholder="Search"
                                className="form-control search"
                                value={search}
                                style={{
                                  width: "210px",
                                  height: "40px",
                                  borderColor: "#d3d3d3",
                                }}
                                onChange={(e) => setSearch(e.target.value)}
                              />
                            </form>
                            <i className="ri-search-line search-icon"></i>
                          </div>
                        )}
                      </div>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="d-flex column-gap  gap-1 justify-content-end align-items-center">
                      <TableItemDisplay pageInfo={pageInfo} />
                      <div
                        style={{
                          width: "2px",
                          height: "20px",
                          backgroundColor: "#adb5bd",
                          marginLeft: "12px",
                        }}
                      ></div>
                      <TableRowsPerPageWithNav
                        pageInfo={pageInfo}
                        pageRequestSet={pageRequestSet}
                      />
                      <ButtonGroup>
                        {checkAnyRole([Role.ADMIN]) && (
                          <TooltipWrapper tooltipText="Delete Multiple">
                            <Button
                              color="light"
                              className="btn-white bg-gradient border-2 border-light-grey fw-bold d-flex flex-row align-items-center"
                              onClick={handleDelete}
                              style={{
                                height: "40px",
                              }}
                            >
                              <i className="mdi mdi-delete align-bottom fs-5"></i>
                            </Button>
                          </TooltipWrapper>
                        )}
                      </ButtonGroup>
                      {checkAnyRole([Role.ADMIN]) && (
                        <Link
                          to="/settings/benefits/add"
                          style={{ color: "black" }}
                        >
                          <Button
                            type="button"
                            className="btn btn-custom-primary header-btn d-flex align-items-center"
                            style={{
                              height: "40px",
                              backgroundColor: "#0A65CC",
                            }}
                          >
                            <span className="fs-3 align-bottom">+</span>
                          </Button>
                        </Link>
                      )}
                    </div>
                  </Col>
                </Row>
                <DynamicTable
                  config={config}
                  data={data}
                  pageRequestSet={pageRequestSet}
                  pageInfo={pageInfo}
                  isLoading={benefitsMeta?.isLoading ?? true}
                  freezeHeader={true}
                  activeRow={activeRow}
                  setTableConfig={setTableConfig}
                  pageRequest={pageRequest}
                  tableHeight="100%"
                />
              </div>
            </Col>
          </Row>
          <DeleteCustomModal
            isOpen={isDeleteModalOpen}
            setIsOpen={setIsDeleteModalOpen}
            confirmDelete={confirmDelete}
            header="Delete Benefit(s)"
            deleteText={
              "Are you sure, you would like to delete this benefit(s)?"
            }
            isLoading={benefitDeleteMeta?.isLoading}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default BenefitsTableWrapper;
